export default "__VITE_ASSET__334d1710__"